import React, { useState } from "react";
import SelectInput from "../common/SelectInput";
import TextInput from "../common/TextInput";
import { useNavigate } from "react-router-dom";
import { Device } from "../common/ObjectTypes";

type DeviceLookupModalProps = {
  isOpen: boolean;
  devices: Device[];
  onClose: Function;
  onChange: Function;
  wildXRNumber: string;
  onDeviceLookup: Function;
  lookupError: string;
};

const DeviceLookupModal = ({
  isOpen,
  devices,
  onClose,
  onChange,
  wildXRNumber,
  onDeviceLookup,
  lookupError,
}: DeviceLookupModalProps) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-2/3 p-6 shadow-lg">
        <div className="flex justify-end items-center border-b pb-3">
          {/* <h2 className="text-xl font-semibold">Change Password</h2> */}
          <button
            onClick={() => onClose()}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>
        {lookupError && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
            role="alert"
          >
            <span className="block sm:inline">{lookupError}</span>
          </div>
        )}
        <div className="flex flex-col">
          <div className="mr-2 w-full">
            <TextInput
              name={"wildXRNumber"}
              label={"Search by WildXR Number"}
              placeholder={""}
              value={wildXRNumber || ""}
              error={() => {}}
              disabled={false}
              className={"bg-white-800 p-2 w-full rounded shadow"}
              type={"text"}
              initialFocus={true}
              onChange={(e: any) => onChange(e)}
            />
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={() => onDeviceLookup()}
            className="bg-tealBlue-500 hover:bg-tealBlue-700 py-2 px-4 ml-2 rounded"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceLookupModal;
